import React from "react";
import { useTranslation } from "react-i18next";
import portrait from "../image/bubuya.jpeg";

/**
 * A pull quote, set the way a magazine would set one: portrait plate on the
 * left, the statement itself large in the display serif. No card, no border
 * radius, no oversized decorative quotation glyph.
 */
export default function Testimonials() {
  const { t } = useTranslation();

  return (
    <section className="section bg-agri-card">
      <div className="container-x">
        <div className="grid grid-cols-1 gap-x-12 gap-y-10 lg:grid-cols-12">
          <figure className="lg:col-span-4">
            <img
              src={portrait}
              alt={`Portrait of ${t("design.testimonial.name")}`}
              loading="lazy"
              className="aspect-[4/5] w-full max-w-[20rem] object-cover object-top grayscale-[0.25]"
            />
            <figcaption className="mt-5 border-t border-agri-rule pt-4">
              <p className="font-display text-[1.0625rem] font-semibold text-agri-ink">
                {t("design.testimonial.name")}
              </p>
              <p className="mt-1 font-mono text-[0.6875rem] uppercase leading-relaxed tracking-[0.1em] text-agri-ink40">
                {t("design.testimonial.role")}
              </p>
            </figcaption>
          </figure>

          <div className="lg:col-span-8 lg:pt-2">
            <p className="kicker-rule">{t("design.testimonial.badge")}</p>

            <blockquote className="mt-7">
              <p className="text-balance font-display text-[1.75rem] font-normal italic leading-[1.32] tracking-[-0.02em] text-agri-ink sm:text-[2.25rem] lg:text-[2.625rem]">
                &ldquo;{t("design.testimonial.quote")}&rdquo;
              </p>
            </blockquote>

            <div className="mt-9 grid grid-cols-1 gap-6 border-t border-agri-rule pt-7 sm:grid-cols-12">
              <p className="font-display text-[1.0625rem] font-semibold leading-snug text-agri-ink sm:col-span-4">
                {t("design.testimonial.title")}
              </p>
              <p className="max-w-measure text-[0.9375rem] leading-[1.7] text-agri-ink80 sm:col-span-8">
                {t("design.testimonial.desc")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
